import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { IUser, WithFiles } from '@vierkant-software/types__api';
import { GcLayoutModule } from '../v-layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { VIconComponent } from '../v-icon/v-icon.component';
import { VUserComponent } from '../v-user/v-user.component';
import { VChipComponent } from 'src/app/modules/wrappers/lib/chip/chip.component';
import { Component, ViewEncapsulation, input, output, computed, inject, Signal, signal, model } from '@angular/core';
import { UserSyncService } from 'src/app/services/userSync.service';

/**
 * Lists several users as chips.
 * 
 * @name User List
 * @tags Display, User, Data
 */
@Component({
    selector:      'v-user-list',
    templateUrl:   './v-user-list.component.haml',
    styleUrls:     ['./v-user-list.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone:    true,
    imports:       [CommonModule, GcLayoutModule, TranslateModule, DragDropModule, VIconComponent, VUserComponent, VChipComponent ]
})
export class VUserListComponent {
    private readonly userService = inject(UserSyncService);
    public users = computed<Signal<IUser & {image_ID?: string}>[]>(() => {
        const value = this.value();
        if (!value) return [];
        const isArray = Array.isArray(value);
        const users = isArray ? value : value.data;
        return users.map((user, index) => {
            if (isArray) return typeof user === "string" ? this.userService.get(user).value : this.userService.get(user.ID).value;
            return signal({...(user as IUser), image_ID: value.__files ? value.__files[index] : undefined});
        });
    });
    public userDict = computed<Record<string, IUser>> (() => {
        const users = this.users();
        const dict: Record<string, IUser> = {};
        users.forEach(userSig => {
            const user = userSig();
            dict[user.ID] = user;
        });
        return dict;
    });
    public emptyString = computed(() => {
        return this.empty() === "all" ? "Alle" : "Keine";
    });

    public emptyIcon = computed(() => {
        return this.empty() === "all" ? "check" : undefined;
    });

    public forceImage = input<boolean>(true);

    /**
     * Users to display. 
     * @values WithFiles<IUser[]> | IUser[]
     */

    public value = model<WithFiles<IUser[]> | IUser[] | string[]>();
    // @Input() public value: WithFiles<IUser[]> | IUser[];
    /**
     * Determines the display if value is empty or unset.
     * 
     * @values  "hidden" | "all" | "empty"
     * @default "hidden"
     */
    public empty = input<"hidden" | "all" | "empty">("hidden");

    public readonly changed = output<IUser[]>();
    public readonly allowDrag = input<boolean>(false);

    drop(event: CdkDragDrop<number>) {
        const data = this.users().map(x => x().ID);
        moveItemInArray(data, event.item.data, event.container.data);
        this.value.set(data);
        this.changed.emit(data.map(x => this.userDict()[x]));
    }
}
